import { devError } from '../utils/log';

import { postRequest } from './api';

export type PurchaseDepositLimitsPreflightData = {
  allowed: boolean;
  reason?: string;
};

export async function postPurchaseDepositLimitsPreflight(
  packageId: number,
): Promise<PurchaseDepositLimitsPreflightData | null> {
  try {
    const response = await postRequest<{ data: PurchaseDepositLimitsPreflightData; errors: unknown[] }>(
      'user/check-purchase-deposit-limits',
      { packageId },
    );
    return response.data;
  } catch (error) {
    devError('purchase deposit limits preflight failed', error);
    return null;
  }
}
